var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import padding from "@irati/ui/src/global/padding";
import { threePxShadowBigBlur } from "@irati/ui/src/global/elevation";
export var DropdownMenu = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "px;\n  margin: ", " 0 0;\n  font-size: 14px;\n  text-align: left;\n  background-color: ", ";\n  border: none;\n  padding: ", ";\n  border-radius: 4px;\n  ", ";\n  background-clip: padding-box;\n"], ["\n  width: ", "px;\n  margin: ", " 0 0;\n  font-size: 14px;\n  text-align: left;\n  background-color: ", ";\n  border: none;\n  padding: ", ";\n  border-radius: 4px;\n  ", ";\n  background-clip: padding-box;\n"])), function (_a) {
    var width = _a.width;
    return width || 180;
}, padding.tiny, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.white;
}, padding.tiny, threePxShadowBigBlur);
var templateObject_1;
